import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class RedditonModel extends BaseAPIModel {
    getInfo({ uuid = null, organizationId = null, eventId = null }) {
        let params = { uuid };
        if (eventId && organizationId) {
            params = { ...params, organizationId, eventId };
        }
        const url = `${this.constructor.listInfo(params)}`;
        return fetcher.get(url, { cache: false }).then(({ response }) => {
            this.data_info = response;
            return this;
        });
    }

    static listInfo({ uuid, organizationId, eventId }) {
        if (!uuid) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }
        if (organizationId && eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/utils/download/${uuid}`;
        }
        return `/ticket/utils/download/${uuid}`;
    }

    getUrlTmp({ organizationId, eventId = null }, queryParams) {
        const url = `${this.constructor.listUrlTmp({ eventId, organizationId })}`;
        return fetcher.post(url, { data: queryParams }).then(({ response }) => {
            this.data_url = response;
            return this;
        });
    }

    static listUrlTmp({ organizationId, eventId }) {
        if (!eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/reddition/download/${eventId}/temp.pdf`;
    }

    getUrl({ organizationId, eventId = null }, queryParams) {
        const url = `${this.constructor.listUrl({ organizationId, eventId })}`;
        return fetcher.post(url, { formData: queryParams }).then(({ response }) => {
            this.data_url = response;
            return this;
        });
    }

    static listUrl({ organizationId, eventId }) {
        if (!eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/reddition/download/${eventId}/complete.pdf`;
    }
}
